import React from 'react';
import { InjectedBreakpointsProps, withBreakpoints } from 'react-match-breakpoints';

import { Typography } from 'app/components/domain/typography';
import { SummaryLine } from 'app/page/orders/model/products-summary';
import { i18n } from 'app/i18n';
import { EquipmentLine } from 'app/components/domain/summary-group/equipment/line/equipment-line';
import { SummaryLineComponent } from 'app/components/domain/summary-group/product/line/summary-line';
import { EquipmentLineBase } from 'app/components/domain/summary-group/equipment/line/equipment-line-base';
import { SummaryGroupBaseComponent } from 'app/components/domain/summary-group/base-components/summary-group-base-component';
import { BreakpointsUtils } from 'app/utils/breakpoints-utils';

interface OwnProps {
    title: string;
    summaryLines: SummaryLine[];
}

type Props = OwnProps & InjectedBreakpointsProps;

class EquipmentSummaryGroupComponent extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { summaryLines } = this.props;

        return (
            <SummaryGroupBaseComponent
                title={this.renderTitleRow()}
                content={<>{summaryLines?.map((group, index) => this.renderGroupSummaryLine(group, index))}</>}
            />
        );
    }

    private readonly renderTitleRow = (): React.ReactNode => {
        const { title, breakpoints } = this.props;

        const isOnDesktop: boolean = !BreakpointsUtils.isOnMobile(breakpoints);

        return (
            <EquipmentLineBase
                title={
                    <Typography variant="subtitle3" component="h4">
                        {title}
                    </Typography>
                }
                quantity={
                    isOnDesktop && (
                        <Typography variant="body1" component="h5">
                            {i18n.summary.productDetails.group.equipment.quantity}
                        </Typography>
                    )
                }
                prices={
                    isOnDesktop && (
                        <Typography variant="body1" component="h5">
                            {i18n.summary.productDetails.group.equipment.totalPrice}
                        </Typography>
                    )
                }
            />
        );
    };

    private readonly renderGroupSummaryLine = (summaryLine: SummaryLine, index: number): React.ReactNode => (
        <React.Fragment key={index}>
            {summaryLine.chargeLine && <EquipmentLine line={summaryLine.chargeLine} />}
            {summaryLine.discountLine && <SummaryLineComponent line={summaryLine.discountLine} discount={true} />}
        </React.Fragment>
    );
}

const EquipmentSummaryGroup = withBreakpoints(EquipmentSummaryGroupComponent);

export { EquipmentSummaryGroup };
